import React from 'react';
import DashboardVisual from '../../components/DashboardVisual';

export default function DashboardPage() {
  return <DashboardVisual />;
}
